import { useMemo } from 'react';
import { Grid } from '@mui/material';

import FlightItineraryBlock from './FlightItineraryBlock';
import FlightItineraryBlockSuccess from './FlightItineraryBlockSuccess';

const FlightItinerary = ({ cluster, isSuccess = false }) => {
  const processedLegs = useMemo(() => {
    if (!cluster?.legs?.length) return [];

    return cluster.legs.map(leg => {
      const option = leg.options[0];
      const firstFlight = option.flights[0];
      const lastFlight = option.flights[option.flights.length - 1];

      const firstAirport = firstFlight.origin_obj.airport?.split('-') || [];

      const lastAirport = lastFlight.destination_obj.airport?.split('-') || [];

      return { option, firstFlight, firstAirport, lastAirport };
    });
  }, [cluster]);

  if (!processedLegs.length) return null;

  // 👇 elegís el componente UNA sola vez
  const BlockComponent = isSuccess
    ? FlightItineraryBlockSuccess
    : FlightItineraryBlock;

  return (
    <Grid id="grid-container-fligth-itineary" container rowSpacing={2}>
      {processedLegs.map(
        ({ option, firstFlight, firstAirport, lastAirport }, index) => (
          <BlockComponent
            key={option.hash}
            option={option}
            firstFlight={firstFlight}
            firstAirport={firstAirport}
            lastAirport={lastAirport}
            cluster={cluster}
            index={index}
          />
        )
      )}
    </Grid>
  );
};

export default FlightItinerary;
